module.exports = __webpack_public_path__ + "img/arrow_drop_down.42039e84.svg";